import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"position":"fixed","top":"calc(50% - 45px)","left":"calc(50% - 45px)","border-radius":"15px","width":"90px","height":"90px","background-color":"rgba(0, 0, 0, 0.75)"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "introduce" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "settingBox" }
const _hoisted_6 = { class: "introduction" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "income" }
const _hoisted_9 = {
  key: 0,
  class: "income"
}
const _hoisted_10 = { class: "red" }
const _hoisted_11 = { class: "price" }
const _hoisted_12 = { class: "new" }
const _hoisted_13 = {
  key: 0,
  class: "old"
}
const _hoisted_14 = {
  key: 3,
  class: "tbr-qr"
}

import { ref, onMounted, computed, nextTick } from "vue";
import { useStore } from "vuex";
import { getUrlParam, parseJSONP } from "@/utils/Util";
import noRight from "@/components/noRight.vue"; // NOSONAR
import hasRightComponts from "@/components/hasRight.vue"; // NOSONAR
import {
  getDetail,
  getPushInfo,
  savePushInfo,
  getProductInfo,
  getPackageInfo,
} from "@/api/index";
import QRCode from "qrcodejs2";
import TextWithEllipsis from "@/components/TextWithEllipsis.vue";
import { showToast } from "vant";

/******************************
 * 初始化配置区
 ******************************/

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

/******************************
 * 模块导入区
 ******************************/
const store = useStore();
const qrCodeDiv = ref<HTMLElement | null>(null); // 二维码容器引用
const environment = ref<string>(""); // 运行环境标识
const showQrcode = ref<boolean>(false); // 是否显示二维码

/******************************
 * URL参数获取区
 ******************************/
const id = getUrlParam("id") as string; // 产品ID
const parameter = { product_id: id, active: 1 }; // API请求参数

/******************************
 * 响应式数据区
 ******************************/
const hasRight = ref<boolean>(false); // 用户权限状态
const list = ref<any>({}); // 产品详情数据
const ccnum = ref<number>(0); // 持仓总市值
const fdyk = ref<number[]>([]); // 浮动盈亏数组
const sy = ref<string>(""); // 收益率
const infos = ref<any>({}); // 组合产品信息
const priceObj = ref<any>({}); // 价格信息
const showPopover = ref<boolean>(false); // 操作菜单显示状态
const noticeType = ref<boolean>(false); // 通知开关状态
const introductionText = ref<string>(""); // 产品介绍文本
const isH5Env = ref<boolean | null>(null); // 是否为移动端
const isLoading = ref<boolean>(true); // 是否加载中
const introduceBox = ref<any>(null); // 产品介绍文本容器

/******************************
 * 计算属性区
 ******************************/
// 是否显示购买区块
const shouldShowBuyBox = computed(() => {
  return (
    !hasRight.value && // 无权限
    infos.value?.status === 2 && // 开放状态
    infos.value?.payUrl?.length > 0 && // 有支付地址
    infos.value?.productPackageInfo !== null && // 解析地址不为null
    (infos.value?.productPackageInfo.groupId != 0 ||
      infos.value?.productPackageInfo.priceId != 0 ||
      infos.value?.productPackageInfo.productId != 0) // 有解析地址并且为有效链接
  );
});

/******************************
 * 生命周期钩子区
 ******************************/
onMounted(async () => {
  // 初始化环境检测
  const { isCDApp, isCJApp, isPROApp, isH5 }: any = window?.httpToHttps?.env;
  isH5Env.value = isH5;
  environment.value = isCDApp
    ? "caidaoapp"
    : isCJApp
    ? "caijingapp"
    : isPROApp
    ? "caidaoapppro"
    : "weixin";

  // 核心数据初始化
  await initializeCoreData();

  // 加载完成
  isLoading.value = false;

  // 二维码处理
  handleQRCodeDisplay(isH5);

  // 权限相关处理
  handlePermissionFeatures();

  // 浏览事件埋点
  initializeTracking();
});

/******************************
 * 核心方法区
 ******************************/
// 初始化核心数据
const initializeCoreData = async (): Promise<void> => {
  // 绑定权限
  const result = await getDetailFn();
  if (result?.code === "0000") {
    // 处理产品详情数据
    hasRight.value =
      result?.result.user_rights && result?.result.user_rights[0]?.hasAccess;
  }
  processDetailData(result);

  // 绑定infos
  infos.value = list.value?.combination;
  // 提交store
  store.commit("setInfos", infos.value);
};

// 二维码显示处理
const handleQRCodeDisplay = (isH5: boolean): void => {
  if (!isH5) {
    // PC才会进行显示
    showQrcode.value = true;
    // 创建二维码
    nextTick(() => generateQRCode());
  }
};

// 权限相关功能处理
const handlePermissionFeatures = (): void => {
  // 有权限
  if (hasRight.value) {
    // 获取推送配置
    getPushConfigFn();
  } else if (infos.value?.status == 2) {
    // 开放状态则获取价格配置
    getPriceFn();
  }
};

// 浏览事件
const initializeTracking = (): void => {
  sendTrackEvent("viewSFZHDetailPage");
};

/******************************
 * 数据获取方法区
 ******************************/
// 获取产品详情
const getDetailFn = (): Promise<object> =>
  new Promise((resolve) => {
    getDetail("410000", JSON.stringify(parameter)).then((res: object) => {
      // 解析JSONP数据
      const result = parseJSONP(res);
      console.log("getDetail", result);
      resolve(result);
    });
  });

// 处理产品详情数据
const processDetailData = (result: any): void => {
  list.value = result.result;
  introductionText.value = list.value.combination.productDesc;

  // 收益计算
  sy.value = list.value?.fund.assets
    ? (
        (list.value?.fund.assets / list.value?.fund.init_assets - 1) *
        100
      ).toFixed(2)
    : "--";
  sy.value = Number(sy.value) == 0 ? "0.00" : sy.value;
  if (list.value?.holds) {
    // 持仓处理
    list.value.holds = list.value.holds.filter(
      (item: any) => item.hold_amount > 0
    );
    list.value.holds.forEach((hold: any) => {
      ccnum.value += hold.market_value;
      fdyk.value.push(
        (hold.last_price - hold.hold_cost_price) * hold.hold_amount
      );
    });
  }

  // Vuex存储
  store.commit("setDetail", result.result);
  store.commit("setFdyk", fdyk.value);

  // 风控初始化
  console.log("初始化风控系统", hasRight.value);
  if (hasRight.value) initializeRiskManagement(result);
};

// 初始化风控系统
const initializeRiskManagement = (result: any): void => {
  window.riskManagementInit({
    again: true,
    modeconfig: 0,
    productid: result.result.product.product_id,
    teacherid: result.result.product.advisor_id,
    userid: result.result.user_rights[0].userID,
    callback: (_res: any) => console.log("风控返回:", _res),
  });
};

/******************************
 * 功能方法区
 ******************************/
// 生成二维码
const generateQRCode = (): void => {
  if (qrCodeDiv.value) {
    new QRCode(qrCodeDiv.value, {
      text: window.location.href,
      width: 140,
      height: 140,
      colorDark: "#333333",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.M,
    });
  }
};

// 获取通知配置
const getPushConfigFn = (): void => {
  getPushInfo(environment.value).then((res: any) => {
    noticeType.value = res.data.quantification;
  });
};

// 保存通知配置
const savePushConfigFn = (): void => {
  savePushInfo({
    type: environment.value,
    quantification: noticeType.value,
  }).then((res: any) => console.log("推送设置保存结果:", res));
};

// 获取价格信息
const getPriceFn = (): void => {
  if (infos.value.productPackageInfo.groupId > 0) {
    getPackageInfo(infos.value.productPackageInfo.groupId, 0).then(
      (res: any) => {
        console.log("单品价格", res);
        priceObj.value = {
          price: res.result.price,
          unit: res.result.units,
          realPrice: res.result.realPrice,
        };
      }
    );
  } else {
    // 没有套餐ID则获取单品价格
    getProductInfo(
      infos.value.productPackageInfo.productId,
      infos.value.productPackageInfo.priceId
    ).then((res: any) => {
      console.log("套餐信息", res);
      priceObj.value = {
        price: res.result.price,
        unit: res.result.unit,
        realPrice: res.result.realPrice,
      };
    });
  }
};

/******************************
 * 事件处理区
 ******************************/
// 开关切换事件
const switchChange = ({ detail }: { detail: boolean }): void => {
  trackEvent(noticeType.value ? "开启推送提醒" : "关闭推送提醒");
  noticeType.value = !noticeType.value;
  savePushConfigFn();
};

// 跳转购买页面
const toBuy = (): void => {
  if (list.value?.combination.status === 0) {
    // 不售卖则进行提示
    showToast("产品暂不支持续订");
    return;
  }
  // 埋点
  trackEvent("立即订阅");
  // 关闭弹窗
  showPopover.value = false;
  // 跳转
  setTimeout(() => (window.location.href = infos.value.payUrl), 300);
};

// 跳转老师工作室
const toTeacherRoom = (): void => {
  showPopover.value = false;
  window.location.href = window.httpToHttps.editHost(
    `https://caidao.homeway.com.cn/${list.value?.combination.teacherId}/index.html`
  );
};

/******************************
 * 工具方法区
 ******************************/

// 埋点跟踪
const trackEvent = (action: string, extra: string = ""): void => {
  sendTrackEvent("clickSFZHDetailPage", action, extra);
};
// 基础埋点方法
const sendTrackEvent = (
  eventName: string,
  action?: string,
  extra?: string
): void => {
  const eventData = {
    page_name: "示范账户详情页",
    special_column_name: list.value?.product.product_name,
    special_column_id: id,
    partner_name: list.value?.product.nick_name,
    partner_id: list.value?.product.advisor_id,
    product_id: list.value?.combination.productId,
    user_permission_status: hasRight.value ? "有权限" : "无权限",
  };

  if (action) {
    eventData.button_name = action + (extra ? ` ${extra}` : "");
  }

  window.sensorsCustom?.sendTrack(eventName, eventData);
};

return (_ctx: any,_cache: any) => {
  const _component_van_switch = _resolveComponent("van-switch")!
  const _component_van_popover = _resolveComponent("van-popover")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[2] || (_cache[2] = [
        _createElementVNode("img", {
          src: "https://imgcd.homeway.com.cn/images/loading.gif",
          style: {"display":"block","width":"70px","position":"relative","top":"calc(50% - 70px / 2)","left":"calc(50% - 70px / 2)"}
        }, null, -1)
      ])))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "introduceBox",
            ref_key: "introduceBox",
            ref: introduceBox
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(list.value?.product?.product_name) + " ", 1),
              (hasRight.value)
                ? (_openBlock(), _createBlock(_component_van_popover, {
                    key: 0,
                    show: showPopover.value,
                    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showPopover).value = $event)),
                    placement: "bottom-end",
                    teleport: introduceBox.value
                  }, {
                    reference: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", { class: "setting" }),
                        _createTextVNode("更多操作")
                      ], -1)
                    ])),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", null, [
                          _cache[3] || (_cache[3] = _createElementVNode("div", null, "通知开关", -1)),
                          _createVNode(_component_van_switch, {
                            "model-value": noticeType.value,
                            "active-color": "#07c160",
                            "onUpdate:modelValue": switchChange
                          }, null, 8, ["model-value"])
                        ]),
                        _createElementVNode("div", { onClick: toBuy }, _cache[4] || (_cache[4] = [
                          _createElementVNode("div", null, "续订服务", -1),
                          _createElementVNode("span", { class: "right" }, null, -1)
                        ])),
                        _createElementVNode("div", { onClick: toTeacherRoom }, _cache[5] || (_cache[5] = [
                          _createElementVNode("div", null, "进入老师工作室", -1),
                          _createElementVNode("span", { class: "right" }, null, -1)
                        ]))
                      ])
                    ]),
                    _: 1
                  }, 8, ["show", "teleport"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(TextWithEllipsis, { text: introductionText.value }, null, 8, ["text"])
            ])
          ], 512)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "incomeTitle" }, "收益率/总", -1)),
              _createElementVNode("p", {
                class: _normalizeClass({
              red: Number(sy.value) > 0,
              green: Number(sy.value) < 0,
              black: Number(sy.value) == 0,
            })
              }, _toDisplayString(sy.value !== "--" ? `${sy.value}%` : "--"), 3)
            ]),
            _createElementVNode("div", null, [
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "incomeTitle" }, "仓位占比", -1)),
              _createElementVNode("p", null, _toDisplayString(list.value?.fund?.market_value
                ? `${(
                    (list.value?.fund?.market_value / list.value?.fund?.assets) *
                    100
                  ).toFixed(2)}%`
                : "--"), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "incomeTitle" }, "持仓数量", -1)),
              _createElementVNode("p", null, _toDisplayString(list.value?.fund?.hold_count || 0), 1)
            ])
          ]),
          (hasRight.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("p", { class: "incomeTitle" }, "总资产", -1)),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(list.value?.fund?.assets.toFixed(2)), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[11] || (_cache[11] = _createElementVNode("p", { class: "incomeTitle" }, "可用余额", -1)),
                  _createElementVNode("p", null, _toDisplayString(list.value?.fund?.current_balance.toFixed(2)), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[12] || (_cache[12] = _createElementVNode("p", { class: "incomeTitle" }, "持仓市值", -1)),
                  _createElementVNode("p", null, _toDisplayString(ccnum.value.toFixed(2)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (!hasRight.value)
          ? (_openBlock(), _createBlock(noRight, { key: 0 }))
          : _createCommentVNode("", true),
        (hasRight.value)
          ? (_openBlock(), _createBlock(hasRightComponts, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["tips", { 'buy-box-show': !shouldShowBuyBox.value || isH5Env.value == null }])
        }, _cache[13] || (_cache[13] = [
          _createElementVNode("span", null, null, -1),
          _createTextVNode(" 本产品是投资决策辅助工具，只根据选股模型做入选股票的走势追踪。 任何指标算法及选股模型均有其特定的适用场景与局限性，请投资者根据自身投资偏好进行选择，并自行做出投资决策。"),
          _createElementVNode("br", null, null, -1),
          _createTextVNode(" 本内容仅供投资参考，不作为投资建议，股市有风险，投资需谨慎 ")
        ]), 2),
        (shouldShowBuyBox.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["buyBox", { static: isH5Env.value == null }])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, "¥" + _toDisplayString(priceObj.value?.realPrice) + "/" + _toDisplayString(priceObj.value?.unit), 1),
                (priceObj.value?.realPrice != priceObj.value?.price)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, " ¥" + _toDisplayString(priceObj.value?.price), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: "button",
                onClick: toBuy
              }, "立即订阅")
            ], 2))
          : _createCommentVNode("", true),
        (showQrcode.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _cache[14] || (_cache[14] = _createElementVNode("p", null, "扫码用手机查看", -1)),
              _createElementVNode("button", {
                class: "tbr-qr-close",
                type: "button",
                "aria-label": "关闭二维码弹窗",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showQrcode.value = false))
              }),
              _createElementVNode("div", {
                class: "chart",
                ref_key: "qrCodeDiv",
                ref: qrCodeDiv
              }, null, 512)
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})